<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-4">
        <ProgressSteps :step="1"></ProgressSteps>
      </div>
      <div class="col-12 col-md-8">
        <div class="q-pa-md border-radius-top q-pt-md-none">
          <div class="bg-white q-pa-md q-mb-md rounded">
            <QuoteSummary
              :quote="{
                image: vehicleImageComputed,
                id: quoteRef,
                make: scoreboard && scoreboard.vehicleDetails ? scoreboard.vehicleDetails.make : '',
                model: scoreboard && scoreboard.vehicleDetails ? scoreboard.vehicleDetails.model : '',
                // year: year,
                price:
                  scoreboard && scoreboard.leaseDetails ? currencyFormatter(scoreboard.leaseDetails.monthlyRentalNet) + priceLabel : '',
                term: scoreboard && scoreboard.leaseDetails ? scoreboard.leaseDetails.terms + ' Months' : ''
              }"
            ></QuoteSummary>
            <div v-if="isWetSignature">
              <div
                class="q-px-md q-py-sm text-center"
                style="background-color: var(--primary-color-background) !important; margin-top: -10px"
              >
                <QBtn color="primary" no-caps outline @click="onClickGetQuotePDF" :loading="loadingViewQuote">Download Quote</QBtn>
                <br /><br />
              </div>
              <div class="q-px-md q-py-sm text-center">
                <br />
                <QBtn color="primary" no-caps @click="onWetSignatureAccept" :loading="loadingAccept">Proceed to Credit Application</QBtn>
                <br /><br />
              </div>
            </div>
            <div v-else>
              <div class="q-pl-md q-pr-md">
                <MainHeadline align="center" body="If you're authorised to approve this quote, click the button below."></MainHeadline>
              </div>
              <div class="q-px-md q-py-sm text-center">
                <QBtn color="primary" no-caps @click="onClickGetQuoteDocusign">Accept Quote & Continue </QBtn>
                <br /><br />
              </div>
            </div>
            <div class="q-py-lg">
              <TextDivider></TextDivider>
            </div>
            <QList bordered class="rounded-borders">
              <QExpansionItem expand-separator>
                <template v-slot:header>
                  <div class="q-item__section column q-item__section--main justify-center">
                    <p style="font-size: 14px; line-height: 25px; margin-bottom: 0">
                      Or, complete the details for an authorised officer
                      <img
                        src="/assets/icons/small-info.svg"
                        :style="convertColourComputed ? convertColourComputed : ''"
                        style="top: 3px; position: relative; cursor: pointer"
                        @click="infoDialogFirst()"
                      />
                      of your company and we'll send them a request.
                    </p>
                  </div>
                </template>
                <QCard>
                  <QCardSection>
                    <QForm @submit.prevent="onSubmit">
                      <InputField
                        label="First Name"
                        placeholder="First Name"
                        v-model="form.firstName"
                        :required="true"
                        :minLength="2"
                        :maxLength="40"
                      />
                      <InputField
                        label="Last Name"
                        placeholder="Last Name"
                        v-model="form.lastName"
                        :required="true"
                        :minLength="2"
                        :maxLength="40"
                      />
                      <InputField
                        label="Email"
                        placeholder="Email"
                        v-model="form.email"
                        type="email"
                        :required="true"
                        :minLength="2"
                        :maxLength="55"
                        :userEmail="user.email"
                      />
                      <InputField
                        v-if="region == 'NZ'"
                        label="Mobile Number"
                        placeholder="Mobile Number"
                        v-model="form.phone"
                        :required="true"
                        type="tel"
                        :minLength="9"
                        :maxLength="12"
                      />
                      <InputField
                        v-else
                        label="Mobile Number"
                        placeholder="Mobile Number"
                        v-model="form.phone"
                        type="tel"
                        :required="true"
                        :length="10"
                      />
                      <div class="q-px-md q-py-md text-center">
                        <QBtn color="primary" type="submit" outline no-caps :loading="loading" :disable="!disableSend">Send</QBtn>
                      </div>
                      <QBtn color="primary" no-caps @click="onNextPage()" id="nextPageButtonId" style="display: none">Next Page</QBtn>
                    </QForm>
                  </QCardSection>
                </QCard>
              </QExpansionItem>
            </QList>
            <QDialog v-model="showDocusign" full-width full-height>
              <QCard>
                <iframe :src="docusignUrl" style="width: 100%; height: calc(100% - 60px)" v-if="docusignUrl"></iframe>
                <div v-else class="flex justify-center items-center q-pa-md" style="width: 100%; height: calc(100% - 60px)">
                  <QSpinner size="md" color="grey-7" />
                </div>
                <div class="text-center">
                  <QBtn color="primary" no-caps @click="onCancel" id="cancelButtonId">Cancel</QBtn>
                </div>
              </QCard>
            </QDialog>
            <NewApplicantDialog
              v-if="showNewApplicantDialog"
              @closeNewApplicantDialog="closeNewApplicantDialog"
              :company="scoreboard.companyDetails.companyName"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { QBtn, QForm, QDialog, QCard, QSpinner, QCheckbox, QExpansionItem, QCardSection, QList } from 'quasar';
import ProgressSteps from '../../components/Molecules/ProgressSteps';
import NewApplicantDialog from '../../components/Molecules/NewApplicantDialog.vue';
import MainHeadline from '../../components/Atoms/MainHeadline';
import QuoteSummary from '../../components/Atoms/QuoteSummary';
import TextDivider from '../../components/Atoms/TextDivider';
import InputField from '../../components/Atoms/InputField';
import MutateReassignQuote from '../../graphql/mutations/MutateReassignQuote';
import MutateGetQuoteDocusign from '../../graphql/mutations/MutateGetQuoteDocusign';
import MutateGetQuotePDF from '../../graphql/mutations/MutateGetQuotePDF';
import MutateDocusignStatus from '../../graphql/mutations/MutateDocusignStatus';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import { GlobalDialog } from '../../components/Dialogs/GlobalDialog';
import WetSignatureMixins from '../../mixins/WetSignatureMixins.js';
import ColoureMixins from '../../mixins/ColourMixins.js';

export default {
  name: 'OrderVerification',
  components: {
    QBtn,
    QForm,
    ProgressSteps,
    MainHeadline,
    QuoteSummary,
    TextDivider,
    InputField,
    QDialog,
    QCard,
    QSpinner,
    //QCheckbox,
    NewApplicantDialog,
    QExpansionItem,
    QCardSection,
    QList
  },
  mixins: [WetSignatureMixins, ColoureMixins],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      user: (state) => state.auth.user
    }),
    ...mapGetters({ isWetSignature: 'vehicleApplication/isWetSignature' }),
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    },
    priceLabel() {
      return this.scoreboard?.currentUser?.region === 'AU' ? '/m (inc GST)' : '/m (ex GST)';
    },
    vehicleImageComputed() {
      if (
        this.scoreboard &&
        this.scoreboard.vehicleDetails &&
        (this.scoreboard.vehicleDetails.vehicleImage.toLowerCase().includes('.jpg') ||
          this.scoreboard.vehicleDetails.vehicleImage.toLowerCase().includes('.png') ||
          this.scoreboard.vehicleDetails.vehicleImage.toLowerCase().includes('.gif') ||
          this.scoreboard.vehicleDetails.vehicleImage.toLowerCase().includes('.jpeg') ||
          this.scoreboard.vehicleDetails.vehicleImage.toLowerCase().includes('https://storage.googleapis.com'))
      )
        return this.scoreboard.vehicleDetails.vehicleImage;
      else if (this.scoreboard?.vehicleDetails?.vehicleImage && this.region == 'NZ') {
        const imagePath = this.scoreboard.vehicleDetails.vehicleImage.replace('*', '.JPG');
        return `https://storage.googleapis.com/ecx-de-db-uat-jato_vehicle_images/Jato/400/${imagePath}`;
      } else return '/assets/temp/car.png';
    },
    convertColourComputed() {
      return this.convertColour();
    },
    disableSend() {
      if (this.form.firstName && this.form.lastName && this.form.email && this.form.phone) return true;
      else return false;
    },
    quoteRef() {
      return this.scoreboard?.quoteDetails?.milesQuoteRef || this.scoreboard?.quoteDetails?.erpQuoteRef || '';
    }
    // year() {
    //   if (this.scoreboard?.vehicleDetails?.variant?.modelYear) {
    //     const date = new Date(
    //       this.scoreboard?.vehicleDetails?.variant?.modelYear
    //     );
    //     return date.getFullYear();
    //   }

    //   return '';
    // }
  },
  data: function () {
    return {
      form: {
        firstName: '',
        lastName: '',
        email: '',
        phone: ''
      },
      wetSignAccepted: false,
      showDocusign: false,
      showNewApplicantDialog: false,
      loading: false,
      loadingAccept: false,
      loadingViewQuote: false,
      docusignUrl: null
    };
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    infoDialogFirst: function () {
      const textAU =
        '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
        '<b>Sole Trader:</b> The owner of the business.<br/><br/>' +
        '<b>Company:</b> A director or company secretary.</span>';
      const textNZ =
        '<span style="color:white"><b>Who is an Authorised Officer?</b><br/><br/>' +
        '<b>Sole Trader:</b> The owner of the business.<br/><br/>' +
        '<b>Company:</b> A director or a person with delegated authority.</span>';

      this.$euiNotifications.emit({
        notification: GlobalDialog,
        body: this.region === 'NZ' ? textNZ : textAU,
        qCardStyle: {
          padding: '0',
          width: '400px',
          maxWidth: '80vw',
          backgroundColor: 'var(--primary-color)'
        },
        closeBtnStyle: {
          color: 'white'
        }
      });
    },
    onCancel: function () {
      this.showDocusign = false;
      this.docusignUrl = null;
    },
    currencyFormatter: function (argument) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      });
      return formatter.format(argument);
    },
    onWetSignatureAccept: async function () {
      this.loadingAccept = true;
      await this.$apollo
        .mutate({
          mutation: MutateDocusignStatus,
          variables: {
            applicationId: this.$store.getters['vehicleApplication/vehicleApplication']
              ? this.$store.getters['vehicleApplication/vehicleApplication'].applicationId
              : null,
            docusignStatus: 'completed'
          }
        })
        .then((data) => {
          this.loadingAccept = false;
          this.onNextPage();
        })
        .catch((error) => {
          this.loadingAccept = false;
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingAccept = false;
    },
    onNextPage: function () {
      this.onCancel();
      this.updateVehicleApplicationState({
        value: 'completed',
        propertyFirst: 'docusignStatus'
      });
      this.updateVehicleApplicationState({
        value: 'businessDetails',
        propertyFirst: 'status'
      });
      this.$router.push({ name: 'businessDetails' });
    },
    onClickGetQuoteDocusign: async function () {
      this.showDocusign = true;
      return await this.$apollo
        .mutate({
          mutation: MutateGetQuoteDocusign,
          variables: {
            returnUrl: `${location.protocol}//${window.location.host}/applications/${this.$store.getters['vehicleApplication/vehicleApplication'].applicationId}/quotesign`
          }
        })
        .then((data) => {
          this.docusignUrl = data.data.getQuoteDocusign.url;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    onClickGetQuotePDF: async function () {
      this.loadingViewQuote = true;

      await this.$apollo
        .mutate({
          mutation: MutateGetQuotePDF
        })
        .then((data) => {
          let self = this;
          const quoteId = self.scoreboard?.quoteDetails?.milesQuoteRef || self.scoreboard?.quoteDetails?.erpQuoteRef || '';

          setTimeout(() => {
            self.downloadFileWSMix(data.data.getQuotePDF.url, `Quote_${quoteId}.pdf`);
          });

          this.loadingViewQuote = false;
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingViewQuote = false;
    },
    onSubmit: async function () {
      this.loading = true;
      return await this.$apollo
        .mutate({
          mutation: MutateReassignQuote,
          variables: {
            userInfo: this.form
          }
        })
        .then((data) => {
          setTimeout(() => {
            this.loading = false;
            this.showNewApplicantDialog = true;
          });
        })
        .catch((error) => {
          this.loading = false;
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
    },
    closeNewApplicantDialog: function () {
      this.showNewApplicantDialog = false;
      this.$router.push({ name: 'logout' });
    }
  }
};
</script>
